const seedrandom = require('seedrandom');

export default function useSeededRandom() {

    return (seed) => seedrandom(seed);

}